const ASSETS_IMAGES_BASE_URL = "https://player-dev.sonyliv.com/platform/web/sportssdk/assets/images";
const ASSETS_FONTS_BASE_URL = "https://player-dev.sonyliv.com/platform/web/sportssdk/assets/fonts"

export {
    ASSETS_IMAGES_BASE_URL,
    ASSETS_FONTS_BASE_URL
}